export const EXPERTISE_STATUSES = {
  WITHOUT_MY_EXPERTISE: 1,
  WITH_MY_EXPERTISE_COMPLETED: 2,
  WITH_MY_EXPERTISE_NOT_COMPLETED: 3,
};

export default {
  EXPERTISE_STATUSES,
};
